export enum DrLicitaTypes {
  GET_DOCUMENTS_REQUEST = '@drLicita/GET_DOCUMENTS_REQUEST',
  GET_DOCUMENTS_SUCCESS = '@drLicita/GET_DOCUMENTS_SUCCESS',
  GET_DOCUMENTS_FAILURE = '@drLicita/GET_DOCUMENTS_FAILURE',
  GET_DOCUMENT_TYPES_REQUEST = '@drLicita/GET_DOCUMENT_TYPES_REQUEST',
  GET_DOCUMENT_TYPES_SUCCESS = '@drLicita/GET_DOCUMENT_TYPES_SUCCESS',
  GET_DOCUMENT_TYPES_FAILURE = '@drLicita/GET_DOCUMENT_TYPES_FAILURE',
  GET_LAW_TYPES_REQUEST = '@drLicita/GET_LAW_TYPES_REQUEST',
  GET_LAW_TYPES_SUCCESS = '@drLicita/GET_LAW_TYPES_SUCCESS',
  GET_LAW_TYPES_FAILURE = '@drLicita/GET_LAW_TYPES_FAILURE',
  DELETE_DOCUMENT_REQUEST = '@drLicita/DELETE_DOCUMENTS_REQUEST',
  DELETE_DOCUMENT_SUCCESS = '@drLicita/DELETE_DOCUMENTS_SUCCESS',
  DELETE_DOCUMENT_FAILURE = '@drLicita/DELETE_DOCUMENTS_FAILURE',
}

export interface DocumentTypeState {
  id: number;
  category_id: number;
  is_active: boolean;
  name: string;
  suggestion_caption: string;
  suggestion_info: string;
}

export interface LawTypeState {
  id: number;
  description: string;
  information: string;
}

interface BlockInventoryType {
  bloc_cd_id: number;
  bloc_tx_objective: string;
  bloc_tx_reference: string;
  bloc_tx_body: string;
  bloc_st_status: string;
  bloc_tx_title: string;
}
export interface DocumentState {
  id: number;
  title: string;
  doc_type_id: number;
  document_type: string;
  law_type_id: number;
  created_at: string;
  template_id: number;
  status: string;
  doc_text: string;
  doc_ref_id: number;
  doc_nr: string;
  conlicita_auth_id: number;
  category_id: number;
  auth_id: number | null;
  blocks: Array<BlockInventoryType>;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface DrLicitaState {
  readonly documents: Array<DocumentState>;
  readonly document_types: Array<DocumentTypeState>;
  readonly law_types: Array<LawTypeState>;
  readonly documents_request: RequestState;
  readonly delete_documents_request: RequestState;
  readonly document_types_request: RequestState;
  readonly law_types_request: RequestState;
}
